export default __webpack_public_path__ + "static/media/line-v-07.e8c3f815.png";